import {db } from "../../firebase";

export const updateTextField = async({payload,user_id}:{user_id:string, payload:{name:string,value:string}}) => {
    db.collection("jobseekers").doc(user_id).set({ [payload.name]: payload.value } ,{merge:true})
}
